import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router';
import Button from '@rio-cloud/rio-uikit/Button';

import { openInfoPage } from '@/features/app/header/info/Info';
import { InfoDialogContentType } from '@/features/app/header/info/InfoDialogDisplaySection';
import { useEngineOilPreconditionsDialog } from '@/features/diagnostics/hooks/useEngineOilPreconditionsDialog';
import { FeedbackOriginEnum } from '@/features/microfrontends/FeedbackCareMfe';
import { EngineOilPreconditions, FillLevelType, Product } from '@/generated/fleetAggregationServiceTypes';
import AnalyticsEvents from '@/utils/analytics/AnalyticsEvents';
import { isEngineOilTypeDid, isEngineOilTypeV2 } from '@/utils/engineOilUtils';
import EngineOilPreconditionsDialog from './vehicleData/EngineOilPreconditionsDialog';

type EngineOilPreConditionsAndFeedbackProps = {
    engineOilType: FillLevelType;
    engineOilPreconditions?: EngineOilPreconditions;
    product?: Product;
};

export const EngineOilPreConditionsAndFeedback = ({ engineOilType, engineOilPreconditions, product }: EngineOilPreConditionsAndFeedbackProps) => {
    const isEngineOilDid = engineOilType === FillLevelType.EngineOilDid;
    const navigate = useNavigate();

    const { engineOilPreconditionsDialog, openEngineOilPreconditionsDialog, closeEngineOilPreconditionsDialog } = useEngineOilPreconditionsDialog();

    const handleClickFeedbackForm = () => {
        if (engineOilType === FillLevelType.EngineOilDid) {
            AnalyticsEvents.openDidFeedbackEngineOil();
        }
        openInfoPage(navigate, location.search, InfoDialogContentType.feedback, FeedbackOriginEnum.ENGINE_OIL);
    };

    const handleClickPreconditionsDialog = () => {
        if (product === Product.ServiceCareM) {
            if (isEngineOilTypeDid(engineOilType)) {
                AnalyticsEvents.openDidMPreconditionsDialog();
            } else if (isEngineOilTypeV2(engineOilType)) {
                AnalyticsEvents.openSensorSignalMPreconditionsDialog();
            }
        } else if (product === Product.ServiceCareS) {
            if (isEngineOilTypeDid(engineOilType)) {
                AnalyticsEvents.openDidSPreconditionsDialog();
            } else if (isEngineOilTypeV2(engineOilType)) {
                AnalyticsEvents.openSensorSignalSPreconditionsDialog();
            }
        }
        openEngineOilPreconditionsDialog();
    };

    return (
        <div className="text-right text-color-primary">
            <span className="cursor-pointer" onClick={handleClickPreconditionsDialog}>
                <FormattedMessage id="intl-msg:fleetstatus.diagnostics.sidebar.section.engine_oil.state.preconditions" />
            </span>

            {isEngineOilDid && (
                <>
                    <span className="separator" style={{ padding: '1px 8px' }}>
                        |
                    </span>
                    <Button onClick={handleClickFeedbackForm}>
                        <span className="rioglyph rioglyph-thumbs-up" />
                        <FormattedMessage id="intl-msg:fleetstatus.diagnostics.sidebar.section.engine_oil.state.feedback.button.rateYourExperience" />
                    </Button>
                </>
            )}

            <EngineOilPreconditionsDialog
                openDialog={engineOilPreconditionsDialog}
                closeDialog={closeEngineOilPreconditionsDialog}
                engineOilType={engineOilType}
                engineOilPreconditions={engineOilPreconditions}
            />
        </div>
    );
};
